export default "__VITE_ASSET__DSLE3e3y__"